/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationFundRef,
  DonationFundRefOptional,
  DonationFundRefMetaI,
  DonationFundRefTrackedI,
} from "./donation-fund-ref";
import {
  DonationFundRefTracked,
  DonationFundRefMeta,
} from "./donation-fund-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationInitiativeRef,
  DonationInitiativeRefOptional,
  DonationInitiativeRefMetaI,
  DonationInitiativeRefTrackedI,
} from "./donation-initiative-ref";
import {
  DonationInitiativeRefTracked,
  DonationInitiativeRefMeta,
} from "./donation-initiative-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Purchasable,
  PurchasableOptional,
  PurchasableMetaI,
  PurchasableTrackedI,
} from "./purchasable";
import { PurchasableTracked, PurchasableMeta } from "./purchasable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";

/**
 *
 * @export
 * @interface DonationBase
 */
export interface DonationBaseOptional extends PurchasableOptional {
  /**
   *
   * @type {number}
   * @memberof DonationBase
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof DonationBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof DonationBase
   */
  voidCloseId?: number;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationBase
   */
  fundId?: DonationFundRefOptional;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  donationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  restriction?: string;
  /**
   *
   * @type {DonationInitiativeRef}
   * @memberof DonationBase
   */
  initiativeId?: DonationInitiativeRefOptional;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  inMemoryOf?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationBase
   */
  isMatch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationBase
   */
  inKind?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationBase
   */
  skipAck?: boolean;
}

export interface DonationBase extends DonationBaseOptional, Purchasable {
  /**
   *
   * @type {number}
   * @memberof DonationBase
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof DonationBase
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof DonationBase
   */
  voidCloseId?: number;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationBase
   */
  fundId: DonationFundRef;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  donationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  restriction?: string;
  /**
   *
   * @type {DonationInitiativeRef}
   * @memberof DonationBase
   */
  initiativeId: DonationInitiativeRef;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  inMemoryOf?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationBase
   */
  isMatch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationBase
   */
  inKind?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationBase
   */
  skipAck?: boolean;
}

export interface DonationBaseTrackedI extends PurchasableOptional {
  /**
   *
   * @type {number}
   * @memberof DonationBase
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof DonationBase
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationBase
   */
  voidCloseId?: number;
  voidCloseIdIsSet: boolean;
  /**
   *
   * @type {DonationFundRef}
   * @memberof DonationBase
   */
  fundId?: DonationFundRefTrackedI;
  fundIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  donationDate?: Date;
  donationDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  description?: string;
  descriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  restriction?: string;
  restrictionIsSet: boolean;
  /**
   *
   * @type {DonationInitiativeRef}
   * @memberof DonationBase
   */
  initiativeId?: DonationInitiativeRefTrackedI;
  initiativeIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationBase
   */
  inMemoryOf?: string;
  inMemoryOfIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationBase
   */
  isMatch?: boolean;
  isMatchIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationBase
   */
  inKind?: boolean;
  inKindIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationBase
   */
  skipAck?: boolean;
  skipAckIsSet: boolean;
}

transformDatesMap.set("DonationBase", function (model: DonationBase) {
  if (typeof model.purchaseDate == "string")
    model.purchaseDate = new Date(model.purchaseDate);
  const transformDatesfundId = transformDatesMap.get("DonationFundRef");
  if (transformDatesfundId && model.fundId) {
    transformDatesfundId(model.fundId);
  }
  if (typeof model.donationDate == "string")
    model.donationDate = new Date(model.donationDate);
  const transformDatesinitiativeId = transformDatesMap.get(
    "DonationInitiativeRef",
  );
  if (transformDatesinitiativeId && model.initiativeId) {
    transformDatesinitiativeId(model.initiativeId);
  }
});

export type DonationBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  voidCloseId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  fundId: PropertyMeta<DonationFundRefMetaI>;
  //isDate: false
  //isDatetime: true
  donationDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  description: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  restriction: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  initiativeId: PropertyMeta<DonationInitiativeRefMetaI>;
  //isDate: false
  //isDatetime: false
  inMemoryOf: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isMatch: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  inKind: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  skipAck: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var DonationBaseMeta: DonationBaseMetaI = {} as DonationBaseMetaI;
DonationBaseMeta = typeMeta("DonationBase", {
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  voidCloseId: propertyMeta(
    "voidCloseId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  fundId: propertyMeta("fundId", false, true, false, DonationFundRefMeta),
  donationDate: propertyMeta(
    "donationDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  description: propertyMeta(
    "description",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  restriction: propertyMeta(
    "restriction",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  initiativeId: propertyMeta(
    "initiativeId",
    false,
    true,
    false,
    DonationInitiativeRefMeta,
  ),
  inMemoryOf: propertyMeta(
    "inMemoryOf",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isMatch: propertyMeta("isMatch", false, false, false, MetaTypesBase.boolean),
  inKind: propertyMeta("inKind", false, false, false, MetaTypesBase.boolean),
  skipAck: propertyMeta("skipAck", false, false, false, MetaTypesBase.boolean),
});

const metaI = DonationBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PurchasableMeta]);
  metaI.price.inheritedFrom = PurchasableMeta.price;
  metaI.purchasableState.inheritedFrom = PurchasableMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = PurchasableMeta.purchaseDate;
  metaI.voidCloseId.inheritedFrom = PurchasableMeta.voidCloseId;
});

export class DonationBaseTracked
  extends PurchasableTracked
  implements DonationBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  voidCloseId__I?: number = undefined;
  voidCloseIdIsSet: boolean = false;
  set voidCloseId(v: undefined | number) {
    if (v !== undefined) {
      this.voidCloseId__I = v;
      this.voidCloseIdIsSet = true;
    } else {
      this.voidCloseId__I = v || undefined;
      this.voidCloseIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get voidCloseId() {
    return this.voidCloseId__I;
  }
  fundId__I?: DonationFundRefTracked = undefined;
  fundIdIsSet: boolean = false;
  set fundId(v: undefined | DonationFundRefTracked) {
    if (v !== undefined) {
      this.fundId__I = v;
      this.fundIdIsSet = true;
    } else {
      this.fundId__I = v || undefined;
      this.fundIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get fundId() {
    return this.fundId__I;
  }
  donationDate__I?: Date = undefined;
  donationDateIsSet: boolean = false;
  set donationDate(v: undefined | Date) {
    if (v !== undefined) {
      this.donationDate__I = v;
      this.donationDateIsSet = true;
    } else {
      this.donationDate__I = v || undefined;
      this.donationDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get donationDate() {
    return this.donationDate__I;
  }
  description__I?: string = undefined;
  descriptionIsSet: boolean = false;
  set description(v: undefined | string) {
    if (v !== undefined) {
      this.description__I = v;
      this.descriptionIsSet = true;
    } else {
      this.description__I = v || undefined;
      this.descriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get description() {
    return this.description__I;
  }
  restriction__I?: string = undefined;
  restrictionIsSet: boolean = false;
  set restriction(v: undefined | string) {
    if (v !== undefined) {
      this.restriction__I = v;
      this.restrictionIsSet = true;
    } else {
      this.restriction__I = v || undefined;
      this.restrictionIsSet = false;
    }
    this.changeTracker = true;
  }
  get restriction() {
    return this.restriction__I;
  }
  initiativeId__I?: DonationInitiativeRefTracked = undefined;
  initiativeIdIsSet: boolean = false;
  set initiativeId(v: undefined | DonationInitiativeRefTracked) {
    if (v !== undefined) {
      this.initiativeId__I = v;
      this.initiativeIdIsSet = true;
    } else {
      this.initiativeId__I = v || undefined;
      this.initiativeIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get initiativeId() {
    return this.initiativeId__I;
  }
  inMemoryOf__I?: string = undefined;
  inMemoryOfIsSet: boolean = false;
  set inMemoryOf(v: undefined | string) {
    if (v !== undefined) {
      this.inMemoryOf__I = v;
      this.inMemoryOfIsSet = true;
    } else {
      this.inMemoryOf__I = v || undefined;
      this.inMemoryOfIsSet = false;
    }
    this.changeTracker = true;
  }
  get inMemoryOf() {
    return this.inMemoryOf__I;
  }
  isMatch__I?: boolean = undefined;
  isMatchIsSet: boolean = false;
  set isMatch(v: undefined | boolean) {
    if (v !== undefined) {
      this.isMatch__I = v;
      this.isMatchIsSet = true;
    } else {
      this.isMatch__I = v || undefined;
      this.isMatchIsSet = false;
    }
    this.changeTracker = true;
  }
  get isMatch() {
    return this.isMatch__I;
  }
  inKind__I?: boolean = undefined;
  inKindIsSet: boolean = false;
  set inKind(v: undefined | boolean) {
    if (v !== undefined) {
      this.inKind__I = v;
      this.inKindIsSet = true;
    } else {
      this.inKind__I = v || undefined;
      this.inKindIsSet = false;
    }
    this.changeTracker = true;
  }
  get inKind() {
    return this.inKind__I;
  }
  skipAck__I?: boolean = undefined;
  skipAckIsSet: boolean = false;
  set skipAck(v: undefined | boolean) {
    if (v !== undefined) {
      this.skipAck__I = v;
      this.skipAckIsSet = true;
    } else {
      this.skipAck__I = v || undefined;
      this.skipAckIsSet = false;
    }
    this.changeTracker = true;
  }
  get skipAck() {
    return this.skipAck__I;
  }
  constructor(config?: DonationBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.fundId?.setIds();

    this.initiativeId?.setIds();
  }
  assignFrom(
    config: DonationBaseOptional,
    options?: AssignOptions,
  ): DonationBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.voidCloseId &&
      this.voidCloseIdApplyFilter(optionsRequired.filter)
    ) {
      this.voidCloseId = config.voidCloseId;
      if (optionsRequired.unassign) this.voidCloseIdIsSet = false;
      else this.voidCloseIdIsSet = true;
    }
    if (config.fundId && this.fundIdApplyFilter(optionsRequired.filter)) {
      this.fundId = new DonationFundRefTracked(config.fundId, options);
      if (optionsRequired.unassign) this.fundIdIsSet = false;
      else this.fundIdIsSet = true;
    }
    if (
      config.donationDate &&
      this.donationDateApplyFilter(optionsRequired.filter)
    ) {
      this.donationDate = config.donationDate;
      if (optionsRequired.unassign) this.donationDateIsSet = false;
      else this.donationDateIsSet = true;
    }
    if (
      config.description &&
      this.descriptionApplyFilter(optionsRequired.filter)
    ) {
      this.description = config.description;
      if (optionsRequired.unassign) this.descriptionIsSet = false;
      else this.descriptionIsSet = true;
    }
    if (
      config.restriction &&
      this.restrictionApplyFilter(optionsRequired.filter)
    ) {
      this.restriction = config.restriction;
      if (optionsRequired.unassign) this.restrictionIsSet = false;
      else this.restrictionIsSet = true;
    }
    if (
      config.initiativeId &&
      this.initiativeIdApplyFilter(optionsRequired.filter)
    ) {
      this.initiativeId = new DonationInitiativeRefTracked(
        config.initiativeId,
        options,
      );
      if (optionsRequired.unassign) this.initiativeIdIsSet = false;
      else this.initiativeIdIsSet = true;
    }
    if (
      config.inMemoryOf &&
      this.inMemoryOfApplyFilter(optionsRequired.filter)
    ) {
      this.inMemoryOf = config.inMemoryOf;
      if (optionsRequired.unassign) this.inMemoryOfIsSet = false;
      else this.inMemoryOfIsSet = true;
    }
    if (config.isMatch && this.isMatchApplyFilter(optionsRequired.filter)) {
      this.isMatch = config.isMatch;
      if (optionsRequired.unassign) this.isMatchIsSet = false;
      else this.isMatchIsSet = true;
    }
    if (config.inKind && this.inKindApplyFilter(optionsRequired.filter)) {
      this.inKind = config.inKind;
      if (optionsRequired.unassign) this.inKindIsSet = false;
      else this.inKindIsSet = true;
    }
    if (config.skipAck && this.skipAckApplyFilter(optionsRequired.filter)) {
      this.skipAck = config.skipAck;
      if (optionsRequired.unassign) this.skipAckIsSet = false;
      else this.skipAckIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DonationBaseTrackedI {
    const cloned = {} as DonationBaseTrackedI;
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.voidCloseIdIsSetDeep() &&
      this.voidCloseIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.voidCloseIdIsSet = true;
      cloned.voidCloseId = this.voidCloseId;
    } else {
      //cloned.voidCloseIdIsSet = false
    }
    if (
      this.fundIdIsSetDeep() &&
      this.fundIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.fundIdIsSet = true;
      cloned.fundId = this.fundId?.removeUnset(filter);
    } else {
      //cloned.fundIdIsSet = false
    }
    if (
      this.donationDateIsSetDeep() &&
      this.donationDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.donationDateIsSet = true;
      cloned.donationDate = this.donationDate;
    } else {
      //cloned.donationDateIsSet = false
    }
    if (
      this.descriptionIsSetDeep() &&
      this.descriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.descriptionIsSet = true;
      cloned.description = this.description;
    } else {
      //cloned.descriptionIsSet = false
    }
    if (
      this.restrictionIsSetDeep() &&
      this.restrictionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.restrictionIsSet = true;
      cloned.restriction = this.restriction;
    } else {
      //cloned.restrictionIsSet = false
    }
    if (
      this.initiativeIdIsSetDeep() &&
      this.initiativeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.initiativeIdIsSet = true;
      cloned.initiativeId = this.initiativeId?.removeUnset(filter);
    } else {
      //cloned.initiativeIdIsSet = false
    }
    if (
      this.inMemoryOfIsSetDeep() &&
      this.inMemoryOfApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.inMemoryOfIsSet = true;
      cloned.inMemoryOf = this.inMemoryOf;
    } else {
      //cloned.inMemoryOfIsSet = false
    }
    if (
      this.isMatchIsSetDeep() &&
      this.isMatchApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isMatchIsSet = true;
      cloned.isMatch = this.isMatch;
    } else {
      //cloned.isMatchIsSet = false
    }
    if (
      this.inKindIsSetDeep() &&
      this.inKindApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.inKindIsSet = true;
      cloned.inKind = this.inKind;
    } else {
      //cloned.inKindIsSet = false
    }
    if (
      this.skipAckIsSetDeep() &&
      this.skipAckApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.skipAckIsSet = true;
      cloned.skipAck = this.skipAck;
    } else {
      //cloned.skipAckIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DonationBaseTrackedI {
    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.voidCloseIdApplyFilter(filter)) this.voidCloseIdIsSet = false;

    if (!this.fundIdApplyFilter(filter)) this.fundIdIsSet = false;
    this.fundId?.unassignAll(filter);

    if (!this.donationDateApplyFilter(filter)) this.donationDateIsSet = false;

    if (!this.descriptionApplyFilter(filter)) this.descriptionIsSet = false;

    if (!this.restrictionApplyFilter(filter)) this.restrictionIsSet = false;

    if (!this.initiativeIdApplyFilter(filter)) this.initiativeIdIsSet = false;
    this.initiativeId?.unassignAll(filter);

    if (!this.inMemoryOfApplyFilter(filter)) this.inMemoryOfIsSet = false;

    if (!this.isMatchApplyFilter(filter)) this.isMatchIsSet = false;

    if (!this.inKindApplyFilter(filter)) this.inKindIsSet = false;

    if (!this.skipAckApplyFilter(filter)) this.skipAckIsSet = false;

    return this;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(DonationBaseMeta.price, DonationBaseMeta, this.price, this);
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.purchasableState,
      DonationBaseMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.purchaseDate,
      DonationBaseMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  voidCloseIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.voidCloseId,
      DonationBaseMeta,
      this.voidCloseId,
      this,
    );
  }
  voidCloseIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.voidCloseIdIsSet && this.voidCloseIdApplyFilter(filter))
      return true;

    return false;
  }
  fundIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(DonationBaseMeta.fundId, DonationBaseMeta, this.fundId, this);
  }
  fundIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.fundIdIsSet && this.fundIdApplyFilter(filter)) return true;
    return this.fundId?.anySet(filter) == true;

    return false;
  }
  donationDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.donationDate,
      DonationBaseMeta,
      this.donationDate,
      this,
    );
  }
  donationDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.donationDateIsSet && this.donationDateApplyFilter(filter))
      return true;

    return false;
  }
  descriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.description,
      DonationBaseMeta,
      this.description,
      this,
    );
  }
  descriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.descriptionIsSet && this.descriptionApplyFilter(filter))
      return true;

    return false;
  }
  restrictionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.restriction,
      DonationBaseMeta,
      this.restriction,
      this,
    );
  }
  restrictionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.restrictionIsSet && this.restrictionApplyFilter(filter))
      return true;

    return false;
  }
  initiativeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.initiativeId,
      DonationBaseMeta,
      this.initiativeId,
      this,
    );
  }
  initiativeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.initiativeIdIsSet && this.initiativeIdApplyFilter(filter))
      return true;
    return this.initiativeId?.anySet(filter) == true;

    return false;
  }
  inMemoryOfApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.inMemoryOf,
      DonationBaseMeta,
      this.inMemoryOf,
      this,
    );
  }
  inMemoryOfIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.inMemoryOfIsSet && this.inMemoryOfApplyFilter(filter)) return true;

    return false;
  }
  isMatchApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.isMatch,
      DonationBaseMeta,
      this.isMatch,
      this,
    );
  }
  isMatchIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isMatchIsSet && this.isMatchApplyFilter(filter)) return true;

    return false;
  }
  inKindApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(DonationBaseMeta.inKind, DonationBaseMeta, this.inKind, this);
  }
  inKindIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.inKindIsSet && this.inKindApplyFilter(filter)) return true;

    return false;
  }
  skipAckApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationBaseMeta.skipAck,
      DonationBaseMeta,
      this.skipAck,
      this,
    );
  }
  skipAckIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.skipAckIsSet && this.skipAckApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.voidCloseIdIsSetDeep(filter)) return true;
    if (this.fundIdIsSetDeep(filter)) return true;
    if (this.donationDateIsSetDeep(filter)) return true;
    if (this.descriptionIsSetDeep(filter)) return true;
    if (this.restrictionIsSetDeep(filter)) return true;
    if (this.initiativeIdIsSetDeep(filter)) return true;
    if (this.inMemoryOfIsSetDeep(filter)) return true;
    if (this.isMatchIsSetDeep(filter)) return true;
    if (this.inKindIsSetDeep(filter)) return true;
    if (this.skipAckIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
